import { Modal } from "@components/Modal";
import { HowToDownloadModal } from "@components/HowToDownloadModal";
import { useTranslation } from "@helpers/useTranslation";
import { useIsCamdeed } from "@helpers/useIsCamdeed";
import { FC, useState } from "react";
import { useFirebaseCachedImageUrl } from "@helpers/useFirebaseCachedImageUrl";

type Props = {
  show: boolean;
  onClose: () => void;
  imageUri: string;
  title: string;
};

export const MobilePhotoDownloadModal: FC<Props> = ({ show, onClose, imageUri, title }) => {
  const { t } = useTranslation("admin");
  const isCamdeed = useIsCamdeed();
  const [showInstructions, setShowInstructions] = useState(false);

  const highResUri = imageUri.replace("_light", "_heavy");
  const highResUrl = useFirebaseCachedImageUrl(highResUri);

  if (!show) return null;

  const handleShowInstructions = () => {
    setShowInstructions(true);
  };

  const handleCloseInstructions = () => {
    setShowInstructions(false);
  };

  return (
    <>
      <Modal show={show} onCancel={onClose} className="z-50" size="xl" hideX>
        <div className="flex flex-col space-y-4">
          {/* Header with "How to download?" link */}
          <div className="flex items-center justify-between pb-2">
            <h3 className="text-lg font-bold">{title}</h3>
            <button onClick={handleShowInstructions} className="text-sm font-medium text-neutral underline">
              {t("howToDownload")}
            </button>
          </div>

          {/* High-res image */}
          <div className="flex justify-center text-sm font-medium text-neutral text-center">
            {t("highResImageNoWatermark")}
          </div>
          <div className="flex justify-center">
            <img
              src={highResUrl}
              alt={title}
              className="h-auto max-w-full rounded-lg shadow-lg"
              style={{
                maxHeight: "70vh",
              }}
            />
          </div>

          {/* Close button */}
          <div className="flex justify-center pt-4">
            <button onClick={onClose} className="btn-ghost btn px-8">
              {t("close")}
            </button>
          </div>
        </div>
      </Modal>

      {/* Instructions modal that appears on top */}
      <HowToDownloadModal show={showInstructions} onClose={handleCloseInstructions} isCamdeed={isCamdeed} />
    </>
  );
};
